import { BarChart3, BookOpenText, CircleDollarSign, LogOut, Menu, Newspaper, ReceiptText, ShieldCheck, UsersRound, X } from "lucide-react";
import { useState, type ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { BrandLogo } from "./Icons";
import { useAuth } from "../auth/AuthContext";

const nav = [
  { to: "/", label: "经营总览", icon: BarChart3, end: true },
  { to: "/projects", label: "矿石项目", icon: BookOpenText },
  { to: "/expenses", label: "其他费用", icon: ReceiptText },
  { to: "/market", label: "每日行情", icon: CircleDollarSign },
  { to: "/news", label: "行业情报", icon: Newspaper },
];

export function AppShell({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const { user, canWrite, logout } = useAuth();
  return (
    <div className="app-shell">
      <button className="mobile-menu" onClick={() => setOpen(true)} aria-label="打开菜单"><Menu size={20} /></button>
      {open && <button className="sidebar-scrim" onClick={() => setOpen(false)} aria-label="关闭菜单" />}
      <aside className={`sidebar ${open ? "is-open" : ""}`}>
        <div className="brand-row">
          <BrandLogo compact />
          <button className="close-menu" onClick={() => setOpen(false)} aria-label="关闭菜单"><X size={18} /></button>
        </div>
        <nav className="sidebar-nav">
          <span className="nav-eyebrow">工作区</span>
          {nav.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} onClick={() => setOpen(false)} className={({ isActive }) => isActive ? "active" : ""}>
              <Icon size={18} strokeWidth={1.8} />{label}
            </NavLink>
          ))}
          {canWrite && <NavLink to="/users" onClick={() => setOpen(false)} className={({ isActive }) => isActive ? "active" : ""}><UsersRound size={18} strokeWidth={1.8} />用户管理</NavLink>}
        </nav>
        <div className="sidebar-foot">
          <div className="side-note"><span className="side-note-icon">Pb·Zn</span><div><strong>氧化铅锌矿</strong><small>首个核算模板</small></div></div>
          <div className="current-user"><span className={`user-avatar ${user?.role}`}>{user?.displayName.slice(0, 1).toUpperCase()}</span><div><strong>{user?.displayName}</strong><small><ShieldCheck size={12} />{canWrite ? "管理员" : "普通账户 · 只读"}</small></div><button type="button" onClick={logout} title="退出登录"><LogOut size={16} /></button></div>
        </div>
      </aside>
      <main className="main-content">{children}</main>
    </div>
  );
}
